import { QuestionnaireEntityInterface, QuestionnaireRendererEntityInterface } from '@types';

export type QuestionnaireState = {
  isCurrentQuestionnaireLoading: boolean;
  currentQuestionnaire: QuestionnaireEntityInterface;
  questionnaireRenderer: QuestionnaireRendererEntityInterface;
  isCurrentQuestionnaireFailure: boolean;
  isQuestionnairesLoading: boolean;
  questionnaires: QuestionnaireEntityInterface[];
  isQuestionnairesFailure: boolean;
  limit: number;
  offset: number;
  total: number;
  //// PUT/DELETE/POST
  isEditingQuestionnaireLoading: boolean;
  editingQuestionnaire: QuestionnaireEntityInterface;
  isEditingQuestionnaireFailure: boolean;
  isDeletingQuestionnaireLoading: boolean;
  isDeletingQuestionnaireFailure: boolean;
};

export const questionnaireInitialState: QuestionnaireState = {
  isCurrentQuestionnaireLoading: false,
  currentQuestionnaire: null,
  questionnaireRenderer: null,
  isCurrentQuestionnaireFailure: false,
  isQuestionnairesLoading: false,
  questionnaires: [],
  isQuestionnairesFailure: false,
  limit: 10,
  offset: 0,
  total: 0,
  //// PUT/DELETE/POST
  isEditingQuestionnaireLoading: false,
  editingQuestionnaire: null,
  isEditingQuestionnaireFailure: false,
  isDeletingQuestionnaireLoading: false,
  isDeletingQuestionnaireFailure: false,
};
